<template>
  <a-config-provider :locale="locale">
    <div id="app" style="overflow: hidden">
      <router-view></router-view>
    </div>
  </a-config-provider>
</template>

<script>
import bus from '@/utils/bus.js';
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';

// 获取app.js 的哈希值
const getAppHash = scripts => {
  let localVersion = '';
  for (let i = 0; i < scripts.length; i++) {
    let src = scripts[i].getAttribute('src');
    if (src && src.indexOf('app.') != -1) {
      // 正则返回中间版本号(如果没有，返回空)
      let regRes = /app\.(.*?).js/;
      if (regRes.test(src)) {
        localVersion = regRes.exec(src)[1];
      }
    }
  }
  return localVersion;
};

// 获取本地的app.js版本号
const getLocalHash = () => {
  return getAppHash(document.getElementsByTagName('script'));
};

// 获取线上的app.js版本号
const checkHash = () => {
  return new Promise((resolve, reject) => {
    // 加上时间戳，防止缓存
    fetch('/?_time=' + Date.now())
      .then(async res => {
        let html = await res.text(); //转成字符串判断
        let doc = new DOMParser().parseFromString(html, 'text/html');
        let newVersion = getAppHash(doc.getElementsByTagName('script'));
        resolve(newVersion);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export default {
  name: 'App',
  data() {
    return {
      mousemove_time: null,
      update_time: null,
      locale: zhCN
    };
  },
  created() {
    // 监听鼠标事件, 节流 300ms 触发一次
    let timer = null;
    window.addEventListener(
      'mousemove',
      () => {
        clearTimeout(timer);
        timer = setTimeout(function () {
          localStorage.setItem('ipp_last_mouse_time', new Date().getTime());
        }, 300);
      },
      true
    );
  },
  mounted() {
    if (window.matchMedia('(orientation: landscape)').matches) {
      localStorage.setItem('ipp_matchMedia', 'landscape');
    } else if (window.matchMedia('(orientation: portrait)').matches) {
      localStorage.setItem('ipp_matchMedia', 'portrait');
    }

    // 监听窗口分辨率变化
    let timer = null;
    window.onresize = () => {
      return (() => {
        clearTimeout(timer);
        timer = setTimeout(function () {
          // 判断横屏、竖屏
          if (window.matchMedia('(orientation: landscape)').matches) {
            localStorage.setItem('ipp_matchMedia', 'landscape');
          } else if (window.matchMedia('(orientation: portrait)').matches) {
            localStorage.setItem('ipp_matchMedia', 'portrait');
          }
          // 通知消息
          bus.$emit('window_resize');
        }, 1000);
      })();
    };

    // if (process.env.NODE_ENV === 'production') {
    //   // 半小时无操作退出系统
    //   clearInterval(this.mousemove_time);
    //   this.mousemove_time = setInterval(() => {
    //     let lastTime = localStorage.getItem('ipp_last_mouse_time') * 1;
    //     if (!lastTime) lastTime = new Date().getTime();
    //     // console.log(localStorage.getItem('ipp_last_mouse_time'));
    //     let nowTime = ['/login'].includes(this.$route.path) ? lastTime : new Date().getTime();
    //     if (nowTime - lastTime > 1000 * 60 * 30) {
    //       clearInterval(this.mousemove_time);
    //       this.$store.dispatch('LogOut');
    //     }
    //   }, 1000);

    //   // 定时执行，自动更新逻辑(每10s检测一次)
    //   clearInterval(this.update_time);
    //   this.update_time = setInterval(async () => {
    //     // 本地
    //     let localVersion = getLocalHash();
    //     // 线上
    //     let newVersion = await checkHash();
    //     // 如果不一样，就进行刷新
    //     if (localVersion != newVersion) {
    //       // this.$notify({
    //       //   title: '更新提示',
    //       //   message: '系统有新版本'
    //       // });
    //       // window.location.reload();
    //     }
    //   }, 10 * 1000);
    // }
  },
  beforeDestroy() {
    clearInterval(this.mousemove_time);
    clearInterval(this.update_time);
    window.removeEventListener('mousemove', () => {}, true);
  },
  methods: {}
};
</script>

<style lang="scss">
.icon-left-top-mark {
  position: absolute;
  top: 10px;
  left: 10px;
  user-select: none;
}

.icon-left-bottom-mark {
  position: absolute;
  bottom: 10px;
  left: 10px;
  user-select: none;
}

.icon-right-top-mark {
  position: absolute;
  top: 10px;
  right: 10px;
  user-select: none;
}

.icon-right-bottom-mark {
  position: absolute;
  bottom: 10px;
  right: 10px;
  user-select: none;
}
</style>
